import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { CodeSetupParameters } from '../models/ui/CodeSetupParameters';
import { APISettings } from '../misc/settings';
import { Observable } from 'rxjs';
import { CodeSetsParameters } from '../models/ui/CodeSetsParameters';

@Injectable({
  providedIn: 'root'
})
export class CodeSetupService {

  constructor(private http: HttpClient) { }

  // submitCodesets(codesets: CodeSetupParameters): Observable<string> {
  //   return this.http.post<string>(`${APISettings.apiBaseAddress}/api/codeset/add/${codesets.ProviderId}`,
  //   codesets, APISettings.httpOptions);
  // }

  submitCodesets(codesets: CodeSetsParameters): Observable<string> {
    return this.http.post<string>(`${APISettings.apiBaseAddress}/api/codeset/add`,
    codesets, APISettings.httpOptions);
  }

  deleteableCodesets(codesets: CodeSetsParameters): Observable<string> {
    return this.http.post<string>(`${APISettings.apiBaseAddress}/api/codeset/delete`,
    codesets, APISettings.httpOptions);
  }
}